<template>
    <div>
      <!-- Mobile Message -->
      <div
        class="md:hidden overflow-auto StepsView page-container flex flex-col items-center justify-center">
        <h1 class="text-xl font-semibold text-[#00423D]">Case for Support</h1>
        <p class="text-primary-300 mt-2 px-4 text-center">
          For optimal viewing experience, please access this page on a desktop
          device.
        </p>
      </div>

      <!-- Main Container  -->
      <div class="hidden md:flex page-container">
        <!-- Side View -->
        <div
          id="side-view"
          class="w-72 min-h-full max-h-full overflow-auto py-2 px-2 shadow-lg border-r border-gray-100">
          <div>
            <TraditionalStyleThemeMini
              :key="keyIndex"
              :selectedFontFamily="selectedFontFamily"
              :selectedHeadingsColor="selectedHeadingsColor"
              :selectedBodyTextColor="selectedBodyTextColor"
              :selectedBackgroundColor="selectedBackgroundColor"
              @emitScrollToElement="handleScrollToElement" />
          </div>
        </div>
        <!-- Main View -->
        <div
          class="flex-1 bg-gray-100 max-h-full overflow-auto p-1 flex flex-col relative">
          <!-- Top Bar -->
          <div class="bg-white rounded-sm p-2">
            <!-- Title and Actions -->
            <div
              class="flex items-center justify-between border-b border-gray-100 pb-1">
              <h1 class="font-archivo font-bold text-xl text-primary-400">
                Case for Support
              </h1>
            </div>
            <!-- Tool Bar -->
            <div class="flex justify-between">
              <div class="flex items-center">
                <p class="text-[#00423D] font-[14px] font-sans">Design:</p>
                <div class="ml-4 flex items-center gap-4">
                  <div class="flex items-center">
                    <p class="text-[#00423D] font-[14px] font-sans">Background</p>
                    <div
                      class="ml-3 flex items-center"
                      @click="onBackgroundColorPickOpen">
                      <color-picker
                        v-model:pureColor="selectedBackgroundColor"
                        v-model:gradientColor="gradientColor"
                        :disableHistory="true"
                        :disableAlpha="true" />
                    </div>
                  </div>

                  <div class="flex items-center">
                    <p class="text-[#00423D] font-[14px] font-sans">Headings</p>
                    <div
                      class="ml-3 flex items-center"
                      @click="onHeadingsColorPickOpen">
                      <color-picker
                        v-model:pureColor="selectedHeadingsColor"
                        v-model:gradientColor="gradientColor"
                        :disableHistory="true"
                        :disableAlpha="true" />
                    </div>
                  </div>

                  <div class="flex items-center">
                    <p class="text-[#00423D] font-[14px] font-sans">Body</p>
                    <div
                      class="ml-3 flex items-center"
                      @click="onBodyTextColorPickOpen">
                      <color-picker
                        v-model:pureColor="selectedBodyTextColor"
                        v-model:gradientColor="gradientColor"
                        :disableHistory="true"
                        :disableAlpha="true" />
                    </div>
                  </div>
                  <div class="flex items-center">
                    <div class="ml-2 flex items-center relative">
                      <label for="font-family-select" class="mr-2 text-[#00423D] font-[14px] font-sans">Font Family:</label>
                      <div class="relative">
                        <select
                          id="font-family-select"
                          v-model="selectedFontFamily"
                          @change="changeFont"
                          class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline focus:border-blue-300">
                          <option v-for="fontFamily in fontFamilies" :key="fontFamily" :value="fontFamily">
                            {{ fontFamily }}
                          </option>
                        </select>
                        <div class="absolute inset-y-0 right-0 flex items-center px-2 text-black z-14">
                          <svg class="fill-current h-4 w-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M10 14l-6-6h12z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-auto">
                <button
                  class="mr-2 text-s text-[#00423D] animate-pulse border border-[#00423D] py-1 px-2 rounded-md"
                  @click="toggleTooltip">
                  Instructions
                </button>
                <QuestionTooltip
                  @on-close-tooltip="toggleTooltip"
                  :tooltip="tooltipContent"
                  :isInstruction="true"
                  v-if="tooltipStatus" />
              </div>
            </div>
          </div>
  
          <!-- Instruction Modal -->
          <InstructionModal 
            :isOpen="isInstructionModalOpen" 
            :content="instructionContent" 
            @close="toggleInstructionModal" 
          />
  
          <!-- //v Document Current Page -->
          <div
            v-if="isLoadingPdf"
            class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div class="w-full h-full flex items-center justify-center">
              <div>
                <div class="text-white">
                  <h3>
                    The system is generating your document in
                    {{ countdown }} seconds
                  </h3>
                </div>
  
                <div class="mt-2 flex items-center justify-center">
                  <ActivityIndicator />
                </div>
              </div>
            </div>
          </div>
  
          <div
            v-if="loadingScreen"
            class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div class="w-full h-full flex items-center justify-center">
              <div>
                <div class="text-white">
                  <h3>The system is {{ loadingScreenType }} the image.</h3>
                </div>
  
                <div class="mt-2 flex items-center justify-center">
                  <ActivityIndicator />
                </div>
              </div>
            </div>
          </div>
  
          <div
            class="flex-1 bg-white mt-1 rounded-sm overflow-auto flex flex-col items-center py-8">
            <div>
              <TraditionalStyleThemeMain
                :selectedFontFamily="selectedFontFamily"
                :selectedHeadingsColor="selectedHeadingsColor"
                :selectedBodyTextColor="selectedBodyTextColor"
                :selectedBackgroundColor="selectedBackgroundColor"
                @emitHandelLodaingScreen="handelLodaingScreen"
                @emitToRefresh="handleRefresh" />
            </div>
          </div>

          <!-- Bottom Bar (Only in Main View) -->
          <div
            class="h-12 bg-white mt-1 rounded-sm flex items-center justify-between fixed bottom-0  w-[calc(100%-20rem)] px-4 shadow-lg">
            <!-- Download options -->
            <div
              id="dropdownTop"
              :class="[
                'z-10',
                'bg-white',
                'divide-y',
                'divide-gray-100',
                'rounded-lg',
                'shadow',
                'w-44',
                'dark:bg-gray-200',
                'absolute',
                'bottom-12',
                'duration-300',
                { hidden: isHidden, visible: isVisible },
              ]">
              <ul
                class="py-2 text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownTopButton"
                :style="{
                  listStyle: 'none'
                }">
                <li>
                  <a
                    href="#"
                    @click="downloadPDF"
                    class="block px-4 py-2 font-bold"
                    :style="{
                      color: selectedHeadingsColor,
                      ...(isHoverpdf
                        ? { background: selectedBackgroundColor }
                        : {}),
                    }"
                    @mouseover="isHoverpdf = true"
                    @mouseleave="isHoverpdf = false"
                    >PDF File</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click="downloadNarrative"
                    class="block px-4 py-2 font-bold"
                    :style="{
                      color: selectedHeadingsColor,
                      ...(isHoverwrd
                        ? { background: selectedBackgroundColor }
                        : {}),
                    }"
                    @mouseover="isHoverwrd = true"
                    @mouseleave="isHoverwrd = false"
                    >Word File</a>
                </li>
              </ul>
            </div>
            <button
              id="dropdownTopButton"
              class="px-10 py-1 inline-block rounded-full font-medium text-white bg-primary-400 duration-300"
              type="button"
              @click="handleToggleClass">
              Download
            </button>
            <button
              v-if="route.path === '/case-statement-document'"
              @click="goToNextModule"
              class="px-10 py-1 inline-block rounded-full font-medium text-white bg-primary-400 duration-300"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  //v Global
  import global from "@/global";
  
  //v Vue Imports
  import { ref, onMounted, reactive, computed, watch } from "vue";
  
  import { useAuthStore } from "@/stores/auth";
  
  import QuestionTooltip from "@/components/QuestionTooltip.vue";
  
  //v Vue Router
  import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
  const router = useRouter();
  const route = useRoute();
  
  //v Vueuse Library
  import {
    onClickOutside,
    useTimeAgo,
    useDateFormat,
    useEyeDropper,
  } from "@vueuse/core";
  
  //v ColorPicker Library
  import { ColorPicker } from 'vue3-colorpicker';
  import 'vue3-colorpicker/style.css';
  
  //v jsPDF and html2canvas Libraries
  import html2canvas from 'html2canvas';
  import { jsPDF } from 'jspdf';
  
  //v Vue input email tags
  import Vue3TagsInput from "vue3-tags-input";
  
  //v Components
  import QuestionTExtarea from "@/components/QuestionTextarea.vue";
  import ActivityIndicator from "@/components/ActivityIndicator.vue";
  
  import TraditionalStyleThemeMain from "@/components/Themes/Main/Traditional.vue";
  
  import TraditionalStyleThemeMini from "@/components/Themes/Mini/Traditional.vue";
  
  // Import the InstructionModal component
  import InstructionModal from '@/components/InstructionModal.vue';
  
  import { useRoutesManagement } from '@/stores/routesManagement';
  
  //v Main
  //v Generic View State----------------------------------------------------------------------------------
  const pureColor = ref("#ffffff");
  const gradientColor = ref(
    "linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%)"
  );
  
  const organization = ref({});
  const caseStatement = ref({});
  const isLoadingPdf = ref(false);
  const countdown = ref(120);
  const isHidden = ref(true);
  const isVisible = ref(false);
  const isHover = ref(false);
  const isHoverpdf = ref(false);
  const isHoverwrd = ref(false);
  
  const selectedBackgroundColor = ref("#");
  const backgroundEyeDropper = useEyeDropper();
  
  const handleToggleClass = () => {
    if (isHidden.value) {
      isHidden.value = false;
      isVisible.value = true;
    } else {
      isHidden.value = true;
      isVisible.value = false;
    }
  };
  
  watch(
    backgroundEyeDropper.sRGBHex,
    (newObj) => {
      selectedBackgroundColor.value = backgroundEyeDropper.sRGBHex.value;
    },
    { deep: true }
  );
  
  const startCountdown = () => {
    const interval = setInterval(() => {
      countdown.value--;
      if (countdown.value == 0 || !isLoadingPdf.value) {
        clearInterval(interval);
      }
    }, 1000);
  };
  
  const brandEyeDropper = useEyeDropper();
  
  const selectedHeadingsColor = ref("#8c2204");
  const headingEyeDropper = useEyeDropper();
  watch(
    headingEyeDropper.sRGBHex,
    (newObj) => {
      selectedHeadingsColor.value = headingEyeDropper.sRGBHex.value;
    },
    { deep: true }
  );
  
  const selectedBodyTextColor = ref("#000000");
  const bodyTextEyeDropper = useEyeDropper();
  watch(
    bodyTextEyeDropper.sRGBHex,
    (newObj) => {
      selectedBodyTextColor.value = bodyTextEyeDropper.sRGBHex.value;
    },
    { deep: true }
  );
  
  async function fetchOrganizationData() {
    try {
      const res = await fetch(`${global.API_URL}/organizations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
      let data = await res.json();
      selectedBackgroundColor.value = data.data.background_color
        ? data.data.background_color
        : "#f4ede2";
      selectedHeadingsColor.value = data.data.headings_color
        ? data.data.headings_color
        : "#8c2104";
      selectedBodyTextColor.value = data.data.body_color
        ? data.data.body_color
        : "#301d17";
      selectedFontFamily.value = data.data.font_family
        ? data.data.font_family
        : "Montserrat";
      organization.value = data.data;
    } catch (err) {
      // console.log(err);
    }
  }
  
  async function fetchDocument() {
    try {
      const res = await fetch(`${global.API_URL}/create_docx`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
  
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
  
      return res.blob();
    } catch (err) {
      console.log(err);
    }
  }
  
  async function downloadNarrative() {
    try {
      const blob = await fetchDocument();
  
      // Create a link element
      const link = document.createElement("a");
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      link.href = url;
  
      // Set the download attribute with a filename
      link.download = "document.doc"; // Set the desired file name
  
      // Append the link to the body
      document.body.appendChild(link);
  
      // Programmatically click the link to trigger the download
      link.click();
  
      // Clean up by revoking the object URL and removing the link element
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
    }
  }
  
  async function postOrganizationData() {
    let data = {
      background_color: selectedBackgroundColor.value,
      headings_color: selectedHeadingsColor.value,
      body_color: selectedBodyTextColor.value,
      font_family: selectedFontFamily.value
    };
    try {
      const res = await fetch(`${global.API_URL}/organizations`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    } catch (err) {
      // console.log(err);
    }
  }
  
  const handleScrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  
  const keyIndex = ref(0);
  
  const handleRefresh = () => {
    keyIndex.value++;
  };
  
  async function fetchCaseStatementData() {
    try {
      const res = await fetch(`${global.API_URL}/case-statements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
      let data = await res.json();
      caseStatement.value = data.data;
    } catch (err) {
      // console.log(err);
    }
  }
  
  const fontFamilies = ref([]);
  const selectedFontFamily = ref('Arial'); // Set the default font family here
  
  const fetchGoogleFonts = async () => {
    try {
      const response = await fetch(
        "https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyADcXPOppBzYWIT_Zw6GAE6gMju5ySoxcQ"
      );
      const data = await response.json();
      const top5GoogleFonts = data.items.slice(0, 5).map((item) => item.family);
  
      const fontList = [
        "Arial", "Calibri", "Cambria", "Courier New", "Georgia", "Impact", "Sans Serif", 
        "Segoe UI", "Tahoma", "Times New Roman", "Verdana", ...top5GoogleFonts
      ];
  
      fontFamilies.value = fontList;
      // Apply the default font once the font list is fetched
      changeFont();
    } catch (error) {
      console.error("Error fetching Google Fonts:", error);
    }
  };
  
  fetchGoogleFonts();
  
  onMounted(async () => {
    await fetchOrganizationData();
    await fetchCaseStatementData();
    changeFont();
  });
  
  watch(
    [
      selectedBackgroundColor,
      selectedHeadingsColor,
      selectedBodyTextColor,
      selectedFontFamily,
    ],
    ([BackgroundColor, HeadingsColor, BodyTextColo, FontFamily]) => {
      postOrganizationData();
    }
  );
  
  
  
  function pushEyeDropperElementToColorPicker(targetPicker) {
    let containerEl = document.querySelector(".vc-display");
    let buttonEl = document.createElement("button");
    buttonEl.classList.add(
      "w-[28px]",
      "h-[28px]",
      "ml-[10px]",
      "flex",
      "items-center",
      "justify-center"
    );
  
    buttonEl.innerHTML = `
    <svg class="h-6 w-6" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1969_29365" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
        <rect width="48" height="48" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_1969_29365)">
        <path d="M7.5 41.9998C7.06667 41.9998 6.70833 41.8581 6.425 41.5748C6.14167 41.2915 6 40.9331 6 40.4998V34.1998C6 33.9998 6.03333 33.8165 6.1 33.6498C6.16667 33.4831 6.28333 33.3165 6.45 33.1498L24.85 14.7498L22.25 12.1498C21.9833 11.8831 21.85 11.5498 21.85 11.1498C21.85 10.7498 22 10.3998 22.3 10.0998C22.5667 9.83314 22.9 9.6998 23.3 9.6998C23.7 9.6998 24.05 9.83314 24.35 10.0998L27.9 13.6998L35 6.5998C35.3667 6.23314 35.7583 6.0498 36.175 6.0498C36.5917 6.0498 36.9833 6.23314 37.35 6.5998L41.4 10.6498C41.7667 11.0165 41.95 11.4081 41.95 11.8248C41.95 12.2415 41.7667 12.6331 41.4 12.9998L34.3 20.0998L37.9 23.6998C38.1667 23.9665 38.3 24.2998 38.3 24.6998C38.3 25.0998 38.1667 25.4331 37.9 25.6998C37.6 25.9998 37.25 26.1498 36.85 26.1498C36.45 26.1498 36.1167 25.9998 35.85 25.6998L33.25 23.1498L14.85 41.5498C14.6833 41.7165 14.5167 41.8331 14.35 41.8998C14.1833 41.9665 14 41.9998 13.8 41.9998H7.5ZM9 38.9998H13.35L31.1 21.2498L26.75 16.8998L9 34.6498V38.9998Z" class="fill-gray-500"/>
      </g>
    </svg>
  `;
    if (targetPicker == "backgroundColor") {
      buttonEl.addEventListener("click", backgroundEyeDropper.open);
      if (backgroundEyeDropper.isSupported.value) {
        containerEl.appendChild(buttonEl);
      }
    } else if (targetPicker == "brandColor") {
      buttonEl.addEventListener("click", brandEyeDropper.open);
      if (brandEyeDropper.isSupported.value) {
        containerEl.appendChild(buttonEl);
      }
    } else if (targetPicker == "headingPicker") {
      buttonEl.addEventListener("click", headingEyeDropper.open);
      if (headingEyeDropper.isSupported.value) {
        containerEl.appendChild(buttonEl);
      }
    } else {
      buttonEl.addEventListener("click", bodyTextEyeDropper.open);
      if (bodyTextEyeDropper.isSupported.value) {
        containerEl.appendChild(buttonEl);
      }
    }
  }
  
  function onBackgroundColorPickOpen(e) {
    pushEyeDropperElementToColorPicker("backgroundColor");
  }
  
  function onBrandColorPickOpen(e) {
    pushEyeDropperElementToColorPicker("brandColor");
  }
  
  function onHeadingsColorPickOpen(e) {
    pushEyeDropperElementToColorPicker("headingPicker");
  }
  
  function onBodyTextColorPickOpen(e) {
    pushEyeDropperElementToColorPicker("bodyPicker");
  }
  
  const loadingScreen = ref(false);
  const loadingScreenType = ref("");
  
  const handelLodaingScreen = (trigger, type) => {
    if (trigger == false) {
      setTimeout(function () {
        loadingScreen.value = trigger;
      }, 2000);
    } else {
      loadingScreen.value = trigger;
      loadingScreenType.value = type;
    }
  };
  
  async function downloadPDF() {
    isLoadingPdf.value = true;
    countdown.value = 120;
    if (isLoadingPdf.value) {
      startCountdown();
    }
  
    const doc = new jsPDF({
      orientation: "p",
      unit: "px",
      format: "a4",
      putOnlyUsedFonts: true,
      floatPrecision: "smart",
    });
  
    const pages = [];
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();
  
    document.querySelectorAll(`.theme-page-TraditionalStyle`).forEach((page) => {
      page.classList.add("!block");
    });
  
    const resizeAndCropImage = (img) => {
      return new Promise((resolve, reject) => {
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const imgWidth = img.naturalWidth;
          const imgHeight = img.naturalHeight;
          const aspectRatio = imgWidth / imgHeight;
          const targetWidth = img.clientWidth * 3; // Increased width for higher resolution
          const targetHeight = img.clientHeight * 3; // Increased height for higher resolution
          const targetAspectRatio = targetWidth / targetHeight;
  
          if (aspectRatio > targetAspectRatio) {
            const scale = targetHeight / imgHeight;
            canvas.width = targetWidth;
            canvas.height = targetHeight;
  
            ctx.drawImage(img, (targetWidth - imgWidth * scale) / 2, 0, imgWidth * scale, targetHeight);
          } else {
            const scale = targetWidth / imgWidth;
            canvas.width = targetWidth;
            canvas.height = targetHeight;
  
            ctx.drawImage(img, 0, (targetHeight - imgHeight * scale) / 2, targetWidth, imgHeight * scale);
          }
          resolve(canvas.toDataURL("image/png", 1.0)); // Ensure maximum quality
        };
        img.onerror = (error) => {
          reject(`Failed to load image: ${error}`);
        };
      });
    };
  
    for (const page of document.querySelectorAll(`.theme-page-TraditionalStyle`)) {
      const pageContent = page;
      const images = pageContent.querySelectorAll("img");
      const imagePromises = Array.from(images).map((img) =>
        resizeAndCropImage(img).then((dataUrl) => {
          img.src = dataUrl;
        }).catch((error) => {
          console.error(error);
        })
      );
  
      await Promise.all(imagePromises);
  
      const canvas = await html2canvas(pageContent, {
        scale: 1.75,
        removeContainer: false,
        allowTaint: true,
        useCORS: true,
      });
      const imgData = canvas.toDataURL("image/png", 1.0); // Ensure maximum quality
      pages.push(imgData);
    }
  
    pages.forEach((page, idx) => {
      doc.addImage(page, "PNG", 0, 0, width, height);
      if (idx < pages.length - 1) {
        doc.addPage();
      }
    });
  
    doc.save(`${organization.value.name} case statement.pdf`);
  
    document.querySelectorAll(`.theme-page-TraditionalStyle`).forEach((page) => {
      page.classList.remove("!block");
    });
  
    isLoadingPdf.value = false;
  }
  
  //v Chat and Invitation----------------------------------------------------------------------------------
  //v View State
  const path = computed(() => route.path);
  const isCollaborationOpen = ref(false);
  const isInvitationOpen = ref(false);
  const message = ref("");
  const messageStack = ref([
    {
      text: "Wow, John What a beautiful mission! 😍",
      time: new Date("Wed Mar 21 2023 17:47:18 GMT+0300 (GMT+03:00)"),
      userName: `Samantha Stew`,
      profilePic:
        "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      text: "But can you change the color please!",
      time: new Date("Wed Mar 21 2023 17:50:18 GMT+0300 (GMT+03:00)"),
      userName: `Samantha Stew`,
      profilePic:
        "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
    {
      text: "Keep it up!",
      time: new Date("Wed Mar 22 2023 17:58:18 GMT+0300 (GMT+03:00)"),
      userName: `Jackson Harper`,
      profilePic: "",
    },
    {
      text: "Awesome job guys 👍",
      time: new Date("Wed Mar 22 2023 18:30:0 GMT+0300 (GMT+03:00)"),
      userName: `Samantha Stew`,
      profilePic:
        "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
  ]);
  
  const isInvitationSent = ref(0);
  const hasFilledEmails = ref(null);
  const isSendingRequest = ref(false);
  const emails = ref([]);
  
  const members = ref([
    {
      userId: "111",
      userName: `Samantha Stew`,
      position: "Team Manager",
      profilePic:
        "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    },
  
    {
      userId: "222",
      userName: `Jackson Harper`,
      position: "Organization Editor",
      profilePic: "",
    },
    {
      userId: "222",
      userName: `Martha Tompala`,
      position: "Organization Editor",
      profilePic: "",
    },
  ]);
  
  //v DOM Refs
  const collaborationWindow = ref(null);
  const invitationWindow = ref(null);
  const chatForm = ref(null);
  const chatArea = ref(null);
  
  //v Pinia Store: Auth
  const authStore = useAuthStore();
  
  function toggleCollaboration() {
    isCollaborationOpen.value = !isCollaborationOpen.value;
  }
  
  function toggleInvitation() {
    isInvitationOpen.value = !isInvitationOpen.value;
  }
  
  onClickOutside(collaborationWindow, (e) => {
    toggleCollaboration();
  });
  
  onClickOutside(invitationWindow, (e) => {
    toggleInvitation();
  });
  
  function pushMessageToMessageStack() {
    // console.log(authStore.user);
    messageStack.value.push({
      text: message.value,
      time: new Date(),
      userName: `${authStore.user.firstName} ${authStore.user.lastName}`,
      profilePic: authStore.user.profilePicture,
    });
    message.value = "";
    setTimeout(() => {
      chatArea.value.scrollTo(0, chatArea.value.scrollHeight);
    }, 10);
  }
  
  function onTextareaKeyDown(e) {
    if (e.key === "Enter") {
      if (!e.shiftKey) {
        if (message.value != 0) {
          chatForm.value.querySelector("textarea").style.height = "46px";
          pushMessageToMessageStack();
        } else {
          chatForm.value.querySelector("textarea").style.height = "46px";
          message.value = "";
        }
      }
    }
  }
  
  function onSubmitMessage(e) {
    if (message.value != 0) {
      chatForm.value.querySelector("textarea").style.height = "46px";
      pushMessageToMessageStack();
    } else {
      chatForm.value.querySelector("textarea").style.height = "46px";
      message.value = "";
    }
  }
  
  //v Handling emails input
  function handleEmailsChange(currEmails) {
    hasFilledEmails.value = true;
    emails.value = currEmails;
  }
  
  function emailValidation(value) {
    const regex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
    return regex.test(value);
  }
  
  // State management and other code
  
  const instructionContent = ref([
    `<b>Customize Your Case For Support</b>
     <br/>Below, please find your case for support. You may customize the following items:
     <br/>- Background Color
     <br/>- Headings Color
     <br/>- Text Color
     <br/>- Images`,
    `<b>Background / Headings / Text Colors –</b> To adjust the background, headings, or text colors, click on the background color button and select the background color you would like in your case for support.`,
    `<b>Images –</b> <br/>- To change any of the images in the case for support, click on the image you want to change and upload an image from your files.
     <br/>- To crop your images, click on the crop button on the upper left side of the image.`
  ]);
  
  const isInstructionModalOpen = ref(false);
  
  // const authStore = useAuthStore();
  
  const toggleInstructionModal = () => {
    isInstructionModalOpen.value = !isInstructionModalOpen.value;
    if (!localStorage.getItem('hasSeenInstructions')) {
      localStorage.setItem('hasSeenInstructions', 'true');
    }
  };
  
  function toggleTooltip() {
    toggleInstructionModal();
  }
  
  // Show modal on first load if not already shown
  onMounted(() => {
    const hasSeenInstructions = localStorage.getItem('hasSeenInstructions');
  
    if (!hasSeenInstructions) {
      isInstructionModalOpen.value = true;
    }
  });
  
  
  function onFormSubmit(e) {
    //v validate inputs
    // console.log(emails);
    const validationResult = emails.value.length != 0 ? true : false;
    if (validationResult) {
      //v Form is Valid
      hasFilledEmails.value = true;
      isSendingRequest.value = true;
      submitBtn.value.disabled = true;
      //v mimic sending request
      setTimeout(() => {
        isSendingRequest.value = false;
        submitBtn.value.disabled = false;
        isInvitationSent.value = 1;
      }, 2000);
    } else {
      //v Form is invalid
      hasFilledEmails.value = false;
    }
  }
  
  function changeFont() {
    let fontLink = `@import url("https://fonts.googleapis.com/css2?family=${selectedFontFamily.value.replace(
      " ",
      "+"
    )}:wght@400;700&display=swap");`;
    const styleElement = document.createElement("style");
    styleElement.textContent = fontLink;
    document.head.appendChild(styleElement);
  }
  
  const routesManagement = useRoutesManagement();
  
  async function goToNextModule() {
    const currentPath = route.path;
    // Mark the current route as completed
    if (routesManagement.routeState[currentPath]?.status !== 1) {
      await routesManagement.updateRouteStatus(currentPath);
      routesManagement.routeState[currentPath] = { status: 1 };
      localStorage.setItem("routesState", JSON.stringify(routesManagement.routeState));
    }
    // Also mark the module 11 section as complete if not already
    const module11CaseSupportPath = routesManagement.getRoutePath(11, 10);
    if (module11CaseSupportPath && module11CaseSupportPath !== currentPath && routesManagement.routeState[module11CaseSupportPath]?.status !== 1) {
      await routesManagement.updateRouteStatus(module11CaseSupportPath);
      routesManagement.routeState[module11CaseSupportPath] = { status: 1 };
      localStorage.setItem("routesState", JSON.stringify(routesManagement.routeState));
    }
    // Now navigate to the next module's first step
    router.push('/steps/gift-pyramid/overview');
  }
  </script>
  
  <style>
  .vc-color-wrap {
    width: 20px !important;
    height: 20px !important;
    box-shadow: rgba(60, 64, 67, 0.154) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.084) 0px 2px 6px 2px !important;
    border-radius: 4px;
  }
  
  .vc-current-color {
    width: 28px !important;
    box-shadow: rgba(60, 64, 67, 0.154) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.084) 0px 2px 6px 2px !important;
    border-radius: 4px;
  }
  
  /* Chat and Invitation */
  .popup-glass {
    background-image: linear-gradient(
      240deg,
      hsla(174, 66%, 15%, 0.512) 0%,
      hsla(173, 71%, 19%, 0.528) 7%,
      hsla(172, 77%, 22%, 0.51) 15%,
      hsla(172, 83%, 25%, 0.506) 28%,
      hsla(172, 90%, 28%, 0.486) 48%,
      hsla(172, 100%, 31%, 0.491) 63%,
      hsla(171, 56%, 42%, 0.471) 73%,
      hsla(172, 42%, 49%, 0.444) 81%,
      hsla(174, 41%, 55%, 0.416) 88%,
      hsla(176, 42%, 60%, 0.36) 94%,
      hsla(179, 45%, 66%, 0.415) 100%
    );
  
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
  }
  
  .tooltip-window {
    animation: move-in 0.8s ease forwards;
  }
  
  @keyframes move-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
  
  .v3ti {
    margin-top: 8px !important;
    min-height: 160px !important;
    border: 1px solid #0d423d !important;
    outline: none !important;
  }
  
  .v3ti.v3ti--focus {
    border: 1px solid #0d423d !important;
    box-shadow: none !important;
  }
  
  .v3ti-content {
    align-content: flex-start !important;
    padding: 5px !important;
  }
  
  .v3ti .v3ti-tag {
    background: #009c87 !important;
  
    border-radius: 100px !important;
    padding-inline: 10px !important;
  }
  
  .v3ti .v3ti-tag .v3ti-remove-tag {
    color: #0d423d !important;
    transition: color 0.3s !important;
    transform: translate(4px, -1px) !important;
  }
  
  .v3ti .v3ti-tag .v3ti-remove-tag:hover {
    color: #ffffff !important;
  }
  
  .shakeX > .v3ti {
    transition: border 0.3s ease-in-out !important;
    border: 1px solid rgb(248 113 113) !important;
  }
  
  .shakeX > .v3ti.v3ti--focus {
    transition: border 0.3s ease-in-out !important;
    border: 1px solid rgb(248 113 113) !important;
  }
  
  .shakeX > .v3ti .v3ti-new-tag::placeholder {
    transition: color 0.3s ease-in-out !important;
    color: rgb(252 165 165) !important;
  }
  
  /*//v themes - pages  */
  .mini-page-landscape {
    transform: scale(0.245);
    transform-origin: top left;
    margin: 10px 0;
    position: relative;
  }

  /* Add new styles for side view container */
  #side-view {
    position: sticky;
    top: 0;
    height: 100vh;
    overflow-y: auto;
    padding: 1rem 1rem 1rem 0rem;
  }

  #side-view .mini-page-landscape {
    margin-bottom: 1.5rem;
  }

  /* Main view container styles */
  .page-container {
    display: flex;
    min-height: 100vh;
  }

  .main-view {
    flex: 1;
    padding: 1rem;
    overflow-y: auto;
  }
  </style>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
  
  * {
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;
    outline: 0;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  .text-center {
    text-align: center;
  }
  
  /* Headings */
  h1 {
    font-size: 48px;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  h2 {
    font-size: 34px;
    font-weight: 800;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 24px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  p {
    font-size: 16px;
    font-weight: 300;
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
    color: #595959;
  }
  
  /* Table */
  table {
    /* border: 1px solid #9fc788; */
    border-collapse: collapse;
  }
  table td,
  table th {
    border: 2px solid #9fc788;
    padding: 0.5rem;
  }
  table thead {
    background-color: #234b29;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
  }
  table tbody {
    background-color: #d5e3cf;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
  }
  table img {
    width: 35px;
    margin: auto;
    display: block;
  }
  
  /* Width */
  .w-1 {
    width: 100%;
  }
  
  /* Margin */
  .mt-2 {
    margin-top: 2rem;
  }
  </style>
  